import styled, { CSSObject } from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { TextButton } from "@swiggy-private/dls-web-core/dist/components/TextButton";
import { FullWidthButton } from "@swiggy-private/dls-web-core/dist/components/FullWidthButton";
import { IM_GIFT_BAG_HALF_CARD_BACKGROUND_IMAGE_URL } from "./constants";
import { getCloudinaryUrl } from "@swiggy-private/js-utils";

const DISCLAIMER_BACKGROUND = `linear-gradient(90deg, rgba(240, 240, 245, 0.00) 0%, rgba(240, 240, 245, 0.60) 50%, rgba(240, 240, 245, 0.00) 100%)`;

export const HalfCardWrapper = styled.div<{ bgImage?: string }>(
    ({ theme, bgImage = IM_GIFT_BAG_HALF_CARD_BACKGROUND_IMAGE_URL }) => {
        return {
            padding: `${theme.spacing.large} ${theme.spacing.medium} ${theme.spacing.large} ${theme.spacing.medium}`,
            paddingBottom: `calc(var(--sab, 0px) + ${theme.spacing.large})`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
            border: `4px solid ${theme.colors[theme.colorMode].background_Primary}`,
            borderTopLeftRadius: theme.cornerRadius.xLarge,
            borderTopRightRadius: theme.cornerRadius.xLarge,
            overflow: "hidden",
            backgroundColor: theme.colors[theme.colorMode].background_Primary,
            background: `url(${getCloudinaryUrl(bgImage)})`,
            backgroundSize: "cover",
        };
    },
);

export const ImageContainer = styled.div(() => {
    return {
        width: "270px",
        height: "176px",
        margin: "0 auto",
    };
});

export const TextHeading = styled(Text)`
    position: relative;
    top: -40px;
    width: 80%;
    text-align: center;
    margin-bottom: ${(props) => props.theme.spacing.small};
`;

export const ItemListWrapper = styled.div(() => {
    return {
        marginTop: "-40px",
        width: "105%",
        marginRight: "-5%",
    };
});

export const ItemWrapper = styled.div<{ isSingleItem: boolean }>(({ theme, isSingleItem }) => {
    return {
        display: "flex",
        width: isSingleItem ? "90vw" : "200px",
        height: "62px",
        flexDirection: "row",
        alignItems: "center",
        flexShrink: 0,
        marginRight: theme.spacing.medium,
        padding: theme.spacing.small,
        paddingLeft: theme.spacing.xxSmall,
        backgroundColor: theme.colors[theme.colorMode].background_Primary,
        borderRadius: theme.cornerRadius.small,
        boxShadow: theme.elevation[theme.colorMode].skim.boxShadow,
        scrollSnapAlign: "start",
        flex: `0 0 ${isSingleItem ? "90vw" : "200px"}`,
    };
});

export const ItemImageWrapper = styled.div(({ theme }) => {
    return {
        width: "50px",
        height: "50px",
        borderRadius: theme.cornerRadius.xSmall,
        objectFit: "cover",
        overflow: "hidden",
        background: theme.colors[theme.colorMode].background_Secondary,
        flex: "0 0 48px",
        marginRight: theme.spacing.small,
    };
});

export const ItemTextWrapper = styled.div(() => {
    return {
        flex: 1,
        display: "flex",
        flexDirection: "column" as CSSObject["flexDirection"],
    };
});

export const HorizontalCarouselContainer = styled.div<{ isSingleItem?: boolean }>(() => {
    return {
        display: "flex",
        alignItems: "center",
        overflowX: "scroll",
        overflowY: "auto",
        scrollSnapType: "x mandatory",
        scrollBehavior: "smooth",
        WebkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": {
            display: "none",
        },
        width: "100%",
        height: "80px",
    };
});

export const HorizontalCarouselWrapper = styled.div(({ theme: _theme }) => {
    return {
        display: "flex",
        flexDirection: "row",
        minWidth: "max-content",
    };
});

export const PaginationDots = styled.div(({ theme }) => {
    return {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginBottom: theme.spacing.medium,
        height: "6px",
    };
});

export const PaginationDot = styled.button<{ isActive: boolean }>(({ theme, isActive }) => {
    const heightAndWidth = isActive ? "6px" : theme.spacing.xxSmall;
    return {
        width: heightAndWidth,
        height: heightAndWidth,
        borderRadius: "50%",
        backgroundColor: isActive
            ? theme.colors[theme.colorMode].text_Med_Emphasis
            : theme.colors[theme.colorMode].text_Low_Emphasis,
        border: "none",
        transition: "all 0.3s ease",
        opacity: isActive ? 1 : 0.6,
        marginLeft: theme.spacing.xxSmall,
    };
});

export const DisclaimerWrapper = styled.div(({ theme }) => {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        maxWidth: "100%",
        padding: `${theme.spacing.xSmall} ${theme.spacing.xSmall}`,
        background: DISCLAIMER_BACKGROUND,
        borderRadius: theme.cornerRadius.small,
        marginTop: theme.spacing.medium,
    };
});

export const DisclaimerText = styled(Text)(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
    flex: 1,
    color: theme.colors[theme.colorMode].text_Low_Emphasis,
}));

export const ButtonWrapper = styled.div(({ theme }) => {
    return {
        marginTop: theme.spacing.xxLarge,
        width: "100%",
    };
});

export const PrimaryTextButton = styled(FullWidthButton)(() => {
    return {
        width: "100%",
    };
});

export const SecondaryTextButton = styled(TextButton)(({ theme }) => {
    return {
        marginTop: theme.spacing.small,
    };
});
